export default __webpack_public_path__ + "static/media/processingIconRed.38edb8a4.svg";